import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  ViewChild,
  AfterViewInit
} from "@angular/core";
import { Router } from "@angular/router";
import { IKeyValueInterface, Permission } from "./../../shared/config";
import { BookingService } from "./../models/booking.service";
import { BookingOverviewList } from "./../models/booking-overviewlist.model";
import {
  WeGoConfig,
  IAPIResponse,
  DataListModel,
  ApplicationRouteURL,
  BookingStatus,
  BookingType
} from "../../shared/config";

const $ = require("jquery");
const moment = require("moment");
const SlimSelect = require("slim-select");

@Component({
  selector: "wego-booking-overview",
  template: require('../views/booking-overview.component.html'),
  providers: [BookingService],
  styles: [
    `
    .search-icon {
        color:#2ba2aa;
    }
    .reset-icon {
        color:#DD9933;
    }
    .export-icon {
        color:#01A2D9;
    }
    .delete-icon {
        color:#f00;
    }
    .cancel-icon {
        color:#f00;
    }
    .add-icon {
        color:#080;
    }
    .nopad-left{
      padding-left: 0px;
    }
    `
  ]
})
export class BookingOverviewComponent implements OnInit {
  permission: string;
  //bookingStatusSpecialSelect: any;
  LblStatus: string;
  LblBookingType: string;
  LblSelect: string;
  bookingStatusSelect: any;

  BookingStatusAll: { Key: string; Value: string }[];
  BookingStatusSpecialBooking: { Key: string; Value: string }[];
  itemPerPageList: number[];
  BookingStatus: { Key: string; Value: string }[];
  BookingTypeList: { Key: string; Value: string }[];

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  apiErrorMsg: string;
  DataListModel: DataListModel;
  errorModel: IKeyValueInterface[];
  readMore: IKeyValueInterface[];
  bookingList: BookingOverviewList[];
  isLoading: boolean;
  isParentCheck: boolean;
  message: string;
  popupMessage: string;
  remarks: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: BookingOverviewList = new BookingOverviewList();
  isParentCheckEnable: boolean;
  remarkslength: number = 15;
  urlBooking: string;
  urlDefaultPage: string;
  urlBookingInformation: string;
  urlDriverBookingInformation: string;
  urlVehicleInfo: string;
  urlDriverInfo: string;
  urlSVGInfo: string;
  bookingHashId: string;
  recurringId: string;
  isRecurringSeriesEditablestring: boolean;
  private popupMsg: string;
  private module: string;
  SingleCancel: boolean;
  NormalBookingView: boolean = true;
  searchLicenceTag: string;
  searchDriverName: string;
  searchSVGName: string;
  bookingTypeSelect: any;
  localTimeZone: string;

  dropdownSettings = {};

  @ViewChild("cancelModal") public cancelModal: any;
  @ViewChild("revokeAborkModal") public revokeAborkModal: any;
  @ViewChild("remarksModal") public remarksModal: any;
  @ViewChild("EditBookingModal") public editBookingModal: any;
  @ViewChild("successPopup") public successPopup: any;

  get isAnyChecked(): boolean {
    if (this.bookingList) {
      let isCheck = this.bookingList.some(x => x.isChecked == true);
      if (isCheck) {
        if (
          this.bookingList
            .filter(
              y => y.isBookingCancel
              // (y.bookingStatus == BookingStatus.CONFIRMED ||
              //   y.bookingStatus == BookingStatus.PENDING)
              //   //&& y.bookingType == BookingType.NORMAL
              //   && y.isDeletable
              //   && y.startDateTime >
              //   moment()
              //     .utc()
              //     .format("DD-MM-YYYY HH:mm")
            )
            .every(x => x.isChecked == true)
        )
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  // get isDeleteAccess(): boolean {
  //   if (this.bookingList) {
  //     return this.bookingList.some
  //             (
  //               y =>
  //               y.isBookingCancel
  //                 // y.isDeletable &&
  //                 // (y.bookingStatus == BookingStatus.CONFIRMED ||
  //                 //   y.bookingStatus == BookingStatus.PENDING) &&
  //                 // // && y.bookingType == BookingType.NORMAL
  //                 // y.startDateTime >
  //                 //   moment()
  //                 //     .utc()
  //                 //     .format("DD-MM-YYYY HH:mm")
  //             );
  //   } else {
  //     return false;
  //   }
  // }

  constructor(
    private authService: AuthService,
    private bookigService: BookingService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.module = this.translate.instant("LblBooking");
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    if (this.authService.IsDriver()) {
      this.DataListModel.searchField = [
        "licenceTag",
        "translatedBookingType",
        "reccuringID",
        "translatedBookingStatus",
        "bookingReferenceID",
        "adminRemarks",
        "driverRemarks",
        "sharedVehicleGroup"
      ];
    } else {
      //  this.DataListModel.searchField = ["licenceTag", "bookingType", "reccuringID", "bookingStatus", "bookingReferenceID", "driver", "adminRemarks", "driverRemarks", "sharedVehicleGroup"];
    }
    this.model = new BookingOverviewList();
    this.model.startDateTime = moment().format("DD-MM-YYYY 00:00");
    this.model.endDateTime = moment()      
      .format("DD-MM-YYYY 23:59");

    this.BookingTypeList = [
      {
        Key: this.translate.instant("LblNORMALBOOKINGTYPE"),
        Value: "NORMAL"
      },
      {
        Key: this.translate.instant("LblMAINTENANCEBOOKINGTYPE"),
        Value: "MAINTENANCE"
      },
      {
        Key: this.translate.instant("LblUNAVAILABLEBOOKINGTYPE"),
        Value: "UNAVAILABLE"
      }
    ];

    this.BookingStatusAll = [
      {
        Key: this.translate.instant("LblABORTED"),
        Value: "ABORTED"
      },
      {
        Key: this.translate.instant("LblCANCELLED"),
        Value: "CANCELLED"
      },
      {
        Key: this.translate.instant("LblCONFIRMED"),
        Value: "CONFIRMED"
      },
      {
        Key: this.translate.instant("LblFINISHED"),
        Value: "FINISHED"
      },
      {
        Key: this.translate.instant("LblNOSHOW"),
        Value: "NOSHOW"
      },
      {
        Key: this.translate.instant("LblPENDING"),
        Value: "PENDING"
      },
      {
        Key: this.translate.instant("LblREVOKED"),
        Value: "REVOKED"
      },
      {
        Key: this.translate.instant("LblRUNNING"),
        Value: "RUNNING"
      },
      {
        Key: this.translate.instant("LblREADYFORPAYMENT"),
        Value: "READYFORPAYMENT"
      }

    ];

    this.BookingStatusSpecialBooking = [
      {
        Key: "CANCELLED",
        Value: "CANCELLED"
      },
      {
        Key: "CONFIRMED",
        Value: "CONFIRMED"
      },
      {
        Key: "FINISHED",
        Value: "FINISHED"
      }
    ];

    this.BookingStatus = this.BookingStatusAll;
    this.model.bookingTypeList = this.BookingTypeList.map(x => x.Value);
    this.model.bookingStatusList = this.BookingStatus.map(x => x.Value);

    console.log(this.model);

    this.model = this.authService.AssignFromStorage(
      this.constructor.name + "_model",
      this.model
    );
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION
    );
    this.urlDriverBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER
    );
    this.urlVehicleInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_INFO
    );
    this.urlDriverInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );
    this.urlSVGInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_SVG_UPDATE
    );

    this.LblSelect = this.translate.instant("LblSelect");
    this.LblBookingType = this.translate.instant("LblBookingType");
    this.LblStatus = this.translate.instant("LblStatus");
    this.permission = Permission.PR_BOOKINGS_OVERVIEW;
    this.searchLicenceTag = this.model.searchLicenceTagList.join();
    this.searchDriverName = this.model.searchDriverNameList.join();
    this.searchSVGName = this.model.searchSVGNameList.join();

    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.DataListModel.itemsPerPage = 10;

    this.GetBookingOverview();

    //  $('#selectbookingType').multiselect();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    //flatPickrConfig.enableSeconds = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetBookingOverview();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetBookingOverview();
  }

  public OnAdvancedSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      "",
      event.isReset
    );
    this.GetBookingOverview();
  }

  public OnDateSearch() {
    this.GetBookingOverview();
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    //this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetBookingOverview();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.bookigService
      .ExportBokingList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "Booking" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  private GetBookingOverview() {
    this.isLoading = true;

    this.model.remarks = null;
    this.model.bookingHashId = "";
    this.model.bookingStatus = "";
    this.model.bookingType = "";

    this.bookigService
      .GetBookingOverviewList(this.model, this.DataListModel)
      .subscribe(
        res => {
          if (res.data) {
            this.bookingList = res.data;
            this.isParentCheckEnable =
              this.bookingList.filter(x => x.isBookingCancel).length > 0
                ? true
                : false;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isLoading = false;
            this.errorModel = null;
          } else {
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = this.translate.instant(
              "LblNoRecords"
            );
            this.errorModel = res.error;
            this.isLoading = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetBookingOverview();
  }

  public OnParentCheck(isChecked: boolean) {
    this.bookingList
      .filter(
        y => y.isBookingCancel
        // &&
        // (y.bookingStatus == BookingStatus.CONFIRMED ||
        //   y.bookingStatus == BookingStatus.PENDING) &&
        // // && y.bookingType == BookingType.NORMAL
        // y.startDateTime >
        //   moment()
        //     .utc()
        //     .format("DD-MM-YYYY HH:mm")
      )
      .forEach(x => (x.isChecked = isChecked));
  }

  onSubmit(forms: any) {
    if (!this.SingleCancel) {
      this.model.listOfBookingHashId = this.bookingList
        .filter(x => x.isChecked)
        .map(x => x.bookingHashId);
      this.CancelBookings(JSON.stringify(this.model));
    } else {
      this.CancelBookings(JSON.stringify(this.model));
    }
  }

  public CancelBookings(formData: any) {
    this.isLoading = true;
    this.bookigService.CancelBookings(formData).subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetBookingOverview();
          this.cancelModal.hide();
          this.isLoading = false;
          this.popupMsg = this.translate.instant("LblBookingCancelSuccess", [
            this.module
          ]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
          this.isLoading = false;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowCancelModal(): void {
    this.SingleCancel = false;
    this.model.remarks = null;
    this.errorModel = null;
    this.cancelModal.show();
  }

  public HideCancelModal(): void {
    this.cancelModal.hide();
  }

  public SuccessCancelModalClick(): void {
    this.cancelModal.hide();
  }

  onSubmitAbortRevoke(forms: any) {
    this.RevokeAbortBooking(JSON.stringify(this.model));
  }

  public RevokeAbortBooking(formData: any) {
    this.isLoading = true;
    this.bookigService.RevokeOrAbortBookings(formData).subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetBookingOverview();
          this.revokeAborkModal.hide();
          this.isLoading = false;
          this.popupMsg =
            this.popupMessage == BookingStatus.ABORTED
              ? this.translate.instant("LblBookingAbortSuccess")
              : this.translate.instant("LblBookingRevokeSuccess");

          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
          this.isLoading = false;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowAbort(bookingHashId: string, bookingStatus: string, localTimeZone: string) {
    this.model.remarks = null;
    this.model.bookingHashId = bookingHashId;
    this.model.bookingStatus = BookingStatus.ABORTED;
    this.model.localTimeZone = localTimeZone;
    this.popupMessage = BookingStatus.ABORTED;
    this.errorModel = null;
    this.revokeAborkModal.show();
  }
  public ShowCancel(bookingHashId: string, bookingStatus: string) {
    this.SingleCancel = true;
    this.model.remarks = null;
    this.errorModel = null;
    this.model.listOfBookingHashId = [bookingHashId];
    this.cancelModal.show();
  }

  public ShowRevoke(bookingHashId: string, bookingStatus: string) {
    this.model.remarks = null;
    this.model.bookingHashId = bookingHashId;
    this.model.bookingStatus = BookingStatus.REVOKED;
    this.popupMessage = BookingStatus.REVOKED;
    this.errorModel = null;
    this.revokeAborkModal.show();
  }

  public HideRevokeAbortModal(): void {
    this.revokeAborkModal.hide();
  }

  public SuccessRevokeAbortModal(): void {
    this.revokeAborkModal.hide();
  }

  //Addedd for remarksModal
  public ShowRemakrsModal(remarks: string) {
    this.remarks = remarks;
    this.remarksModal.show();
  }
  public HideRemarksModal() {
    this.remarks = null;
    this.remarksModal.hide();
  }

  //Addedd for edit recurringbooking
  public ShowBookingModal(
    isRecurringSeriesEditable: boolean,
    bookingHashId?: string,
    recurringID?: string
  ): void {
    if (isRecurringSeriesEditable) {
      if (bookingHashId) this.bookingHashId = bookingHashId;
      if (recurringID) this.recurringId = recurringID;
      this.editBookingModal.show();
    } else {
      if (bookingHashId) this.bookingHashId = bookingHashId;
      this.router.navigate([this.urlBooking, { ref: this.bookingHashId }]);
    }
  }

  public SuccessSingleBooking(): void {
    this.editBookingModal.hide();
    this.router.navigate([
      this.urlBooking,
      { ref: this.bookingHashId, isRecurring: false }
    ]);
  }

  public SuccessRecurringBooking(): void {
    this.editBookingModal.hide();
    this.router.navigate([
      this.urlBooking,
      { ref: this.recurringId, isRecurring: true }
    ]);
  }

  public HideBookingModal(): void {
    this.editBookingModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
    this.authService.SaveToStorage(
      this.constructor.name + "_model",
      this.model
    );
  }

  public OnAdvancedReset(event: any) {
    console.log($("#bookingType").val());

    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      "",
      event.isReset
    );

    this.model.searchDriverNameList = [];
    this.searchDriverName = "";
    this.model.driverHashId = "";
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = "";
    this.model.vehicleHashId = "";
    this.model.searchSVGNameList = [];
    this.searchSVGName = "";
    this.model.sharedVehicleGroupHashId = "";
    this.model.startDateTime = moment().format("DD-MM-YYYY 00:00");
    this.model.endDateTime = moment()
      .add(+1, "M")
      .format("DD-MM-YYYY 00:00");
    this.model.bookingReferenceId = "";
    this.model.bookingStatus = "";
    this.model.bookingType = "";
    this.model.searchDriverNameList = [];
    this.searchDriverName = "";
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = "";
    this.model.searchSVGNameList = [];
    this.searchSVGName = "";

    this.model.sharedVehicleGroupHashIdList = [];
    this.model.vehicleHashIdList = [];
    this.model.driverHashIdList = [];

    this.model.bookingTypeList = this.BookingTypeList.map(x => x.Value);
    this.model.bookingStatusList = this.BookingStatus.map(x => x.Value);

    this.bookingTypeSelect.set(this.model.bookingTypeList);
    this.bookingStatusSelect.set(this.model.bookingStatusList);
    //this.bookingStatusSpecialSelect.set(this.model.bookingStatusList);

    this.NormalBookingView = true;
    this.GetBookingOverview();
  }

  public BookingTypeChange() {
    if (!(this.model.bookingType == "" || this.model.bookingType == "NORMAL")) {
      if (this.model.vehicleHashId != "") {
        this.model.searchLicenceTagList = [];
        this.searchLicenceTag = "";
        this.model.vehicleHashId = "";
      }
      this.model.searchSVGNameList = [];
      this.searchSVGName = "";
      this.model.sharedVehicleGroupHashId = "";
      this.NormalBookingView = false;
      this.BookingStatus = this.BookingStatusSpecialBooking;
      this.model.bookingStatus = "";
    } else {
      this.BookingStatus = this.BookingStatusAll;
      this.model.bookingStatus = "";
      this.NormalBookingView = true;
    }
  }

  public BookingTypeChangeMultiSelect() {
    // if (this.model.bookingTypeList.indexOf("") > -1) {
    //   this.model.bookingTypeList = this.BookingTypeList.map(x => x.Value);
    // }

    if (this.bookingStatusSelect) {
      if (this.model.bookingTypeList.indexOf("NORMAL") > -1) {
        this.NormalBookingView = true;
        // // this.BookingStatus = this.BookingStatusAll;
        // //this.RenderBookingStatus();
        // this.model.bookingStatusList = this.BookingStatus.map(x => x.Value);
        // this.bookingStatusSelect.set(this.model.bookingStatusList);
        // this.bookingStatusSpecialSelect.set(this.model.bookingStatusList);

        // $('.' + this.bookingStatusSpecialSelect.config.id).css('display', 'none');
        // $('.' + this.bookingStatusSelect.config.id).css('display', 'block');
      } else {
        this.NormalBookingView = false;
        // // this.BookingStatus.forEach(x => { x.enabled = (this.BookingStatusSpecialBooking.filter(y => y.Value == x.Value).length > 0) });
        // //this.BookingStatus = this.BookingStatusSpecialBooking;
        // // this.RenderBookingStatus();
        // this.model.bookingStatusList = this.BookingStatusSpecialBooking.map(x => x.Value);
        // this.bookingStatusSelect.set(this.model.bookingStatusList);
        // this.bookingStatusSpecialSelect.set(this.model.bookingStatusList);
        // $('.' + this.bookingStatusSpecialSelect.config.id).css('display', 'block');
        // $('.' + this.bookingStatusSelect.config.id).css('display', 'none');
      }
    }

    // this.bookingStatusSelect.render();

    // this.bookingStatusSelect.setData(this.BookingStatus.map((x: any) => {
    //   return {
    //     text: x.Key,
    //     value: x.Value,
    //   };
    // }));
  }

  public BookingStatusChanged() {
    // if (this.model.bookingStatusList.indexOf("") > -1) {
    //   this.model.bookingStatusList = this.BookingStatus.map(x => x.Value);
    // }
  }

  public SuccessSelectVehicleModal($event: any) {
    this.model.searchLicenceTagList = $event.LicenceTage;
    this.searchLicenceTag = this.model.searchLicenceTagList.join();
    this.model.vehicleHashIdList = $event.VehicleMasterHashID;
  }

  public SuccessSelectDriverModal($event: any) {
    this.model.searchDriverNameList = $event.DriverName;
    this.searchDriverName = this.model.searchDriverNameList.join();
    this.model.driverHashIdList = $event.DriverHashID;
  }

  public SuccessSelectSvgModal($event: any) {
    this.model.searchSVGNameList = $event.SvgName;
    this.searchSVGName = this.model.searchSVGNameList.join();
    this.model.sharedVehicleGroupHashIdList = $event.SvgMasterHashID;
  }

  public ClearDriver() {
    this.model.searchDriverNameList = [];
    this.searchDriverName = "";
    this.model.driverHashId = "";
    this.model.driverHashIdList = [];
  }
  public ClearVehicle() {
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = "";
    this.model.vehicleHashId = "";
    this.model.vehicleHashIdList = [];
  }
  public ClearSvg() {
    this.model.searchSVGNameList = [];
    this.searchSVGName = "";
    this.model.sharedVehicleGroupHashId = "";
    this.model.sharedVehicleGroupHashIdList = [];
  }

  ngAfterViewInit() {
    this.bookingTypeSelect = new SlimSelect({
      select: "#bookingType",
      placeholder: this.LblSelect + " " + this.LblBookingType,
      showSearch: false,
      onChange: (info: any) => {
        this.model.bookingTypeList = info.map((x: any) => x.value);
        //console.log(info);
      }
    });

    this.bookingTypeSelect.set(this.model.bookingTypeList);

    this.RenderBookingStatus();
    this.bookingStatusSelect.set(this.model.bookingStatusList);
    //this.bookingStatusSpecialSelect.set(this.model.bookingStatusList);

    // $('.' + this.bookingStatusSpecialSelect.config.id).css('display', 'none');
    // $('.' + this.bookingStatusSelect.config.id).css('display', 'block');
  }

  private RenderBookingStatus() {
    // if (this.NormalBookingView) {
    this.bookingStatusSelect = new SlimSelect({
      select: "#bookingStatus",
      placeholder: this.LblSelect + " " + this.LblStatus,
      showSearch: false,
      showContent: "down",
      onChange: (info: any) => {
        // if (this.NormalBookingView) {
        this.model.bookingStatusList = info.map((x: any) => x.value);
        // }
        //console.log(info);
      }
      //showContent:'down'
    });
    // } else {
    // this.bookingStatusSpecialSelect = new SlimSelect({
    //   select: '#bookingStatusSpecial',
    //   placeholder: this.LblSelect + " " + this.LblStatus,
    //   showSearch: false,
    //   onChange: (info: any) => {
    //     if (!this.NormalBookingView) {
    //       this.model.bookingStatusList = info.map((x: any) => x.value)
    //     }
    //     //console.log(info);
    //   }
    //   //showContent:'down'
    // });
    // }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-overview.component.ts